import { IsNotEmpty } from "class-validator";

export default class DeleteCompanyGroupReq {
  @IsNotEmpty({
    message: "",
  })
  readonly companyGroupId: number;

  constructor(arg: any) {
    arg = arg || {};
    this.companyGroupId = arg.companyGroupId;
  }
}
